import React from "react";

const W = 100;
const H = 28;

// Polyline points for a sparkline; null when there is nothing to draw.
export function sparklinePoints(values) {
  const v = (values || []).filter((x) => typeof x === "number" && Number.isFinite(x));
  if (v.length < 2) return null;
  const lo = Math.min(...v);
  const span = Math.max(...v) - lo || 1;
  return v
    .map((y, i) => `${((i / (v.length - 1)) * W).toFixed(1)},${(H - 2 - ((y - lo) / span) * (H - 4)).toFixed(1)}`)
    .join(" ");
}

export default function KpiCardWidget({ title, value, unit, values = [] }) {
  const points = sparklinePoints(values);
  const first = values.find((x) => typeof x === "number");
  const num = Number(value);
  const delta = Number.isFinite(num) && typeof first === "number" && first !== 0 ? ((num - first) / Math.abs(first)) * 100 : null;
  return (
    <div style={styles.card}>
      <div style={styles.title} title={title}>{title}</div>
      <div style={styles.row}>
        <span style={styles.value}>{value}</span>
        {unit && <span style={styles.unit}>{unit}</span>}
        {delta != null && (
          <span style={{ ...styles.delta, color: "var(--vx-text-2)" }}>
            {delta >= 0 ? "▲" : "▼"} {Math.abs(delta).toFixed(1)}%
          </span>
        )}
      </div>
      <svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" style={styles.spark} aria-hidden="true">
        {points && (
          <polyline points={points} fill="none" stroke="var(--vx-accent)" strokeWidth="1.5" vectorEffect="non-scaling-stroke" />
        )}
      </svg>
    </div>
  );
}

const styles = {
  card: {
    height: "100%",
    boxSizing: "border-box",
    padding: "10px 14px",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    overflow: "hidden",
    background: "var(--vx-surface)",
    fontFamily: "var(--vx-font-sans)",
  },
  title: {
    fontSize: "12px",
    fontWeight: 600,
    color: "var(--vx-text-2)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  row: { display: "flex", alignItems: "baseline", gap: "6px", flexWrap: "wrap" },
  value: { fontFamily: "var(--vx-font-mono)", fontSize: "26px", fontWeight: 500, color: "var(--vx-text)", lineHeight: 1.1 },
  unit: { fontSize: "12px", color: "var(--vx-text-2)" },
  delta: { fontFamily: "var(--vx-font-mono)", fontSize: "11px", marginLeft: "auto" },
  spark: { flex: 1, minHeight: 0, width: "100%" },
};
